import { truckListQuerySchema } from '@chukua/common';
import { Select } from 'antd';
import { useCallback } from 'react';
import { useRemoteMultiSearchOptions } from '../../../../../shared/hooks/use-remote-multi-search-options';
import { getTruck, listTrucks } from '../trucks.api';

const PAGE_SIZE = 20;

interface TruckSearchMultiSelectProps {
  id?: string;
  value?: string[];
  onChange?: (value: string[]) => void;
  disabled?: boolean;
}

/** Remote-search picker for several trucks: `GET /trucks?q=` by registration, make or model, opening on the first page. Saved ids are fetched so their registrations show. */
export function TruckSearchMultiSelect({ id, value, onChange, disabled }: TruckSearchMultiSelectProps) {
  const fetchTrucks = useCallback(
    (q: string | undefined) =>
      listTrucks(truckListQuerySchema.parse({ q, pageSize: PAGE_SIZE })).then((page) =>
        page.items.map((truck) => ({ value: truck.id, label: `${truck.registration} · ${truck.make} ${truck.model}` })),
      ),
    [],
  );
  const fetchTruck = useCallback(
    (truckId: string) => getTruck(truckId).then((truck) => ({ value: truck.id, label: `${truck.registration} · ${truck.make} ${truck.model}` })),
    [],
  );
  const selectProps = useRemoteMultiSearchOptions(fetchTrucks, fetchTruck, value);

  return (
    <Select
      {...selectProps}
      mode="multiple"
      id={id}
      value={value}
      onChange={onChange}
      disabled={disabled}
      placeholder="Select or search trucks"
      notFoundContent={selectProps.loading ? 'Searching…' : 'No trucks found'}
    />
  );
}
